import Vue from "vue";

Vue.filter("datetime", value => {
  return new Date(value).toLocaleString();
});
